export function check(state) {
  return state.check;
}